export const camelToSnakeCase = (str) => {
  return str ? str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`) : str;
};
